module.exports = require("@ember/object/compat");